import { isElementNode, copyElementAttributes } from 'anodum';

const transformElementTag = (element, tagName) => {
  if (!isElementNode(element)) {
    console.error(`${element} is not an element`);
    return null;
  }

  const { ownerDocument: liveDocument } = element;
  const transformedElement = liveDocument.createElement(tagName);
  const fragment = document.createDocumentFragment();
  const childNodes = Array.from(element.childNodes);

  fragment.append(...childNodes);
  transformedElement.append(fragment);
  copyElementAttributes(element, transformedElement);
  element.replaceWith(transformedElement);
  return transformedElement;
};

export default transformElementTag;
